export default __webpack_public_path__ + "static/media/9_1_2.0a2a14a8.png";